import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import UsersTable from "./UsersTable";

const UsersList = () => {
    return (
        <Fragment>
            <UsersTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />
        </Fragment>
    )
}

export default UsersList